export default __webpack_public_path__ + "static/media/Skyshear Boots.de038c79.jpg";